import React, { useState, useEffect } from "react";
import Contact from "../components/Contact";
import contentService from "../services/contentService";

export default function ContactPage() {
  const [contactContent, setContactContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContactContent = async () => {
      try {
        // For now, we'll use static content since contact doesn't have a specific API
        // In the future, you can create a contact content API
        setContactContent({
          title: "Contact Nexen Consulting",
          description: "We're here to help! Reach out for a consultation, quote, or any question—our experts will respond promptly.",
          address: "DALLAS, GA, 30132, USA",
          email: "info@nexenconsults.com",
          phone: "+91 996-696-9809",
          officeHours: "Monday – Saturday: 24/7 Support, PST\nSunday: By Appointment"
        });
        setLoading(false);
      } catch (err) {
        setError("Failed to load content");
        console.error("Error fetching contact content:", err);
        setLoading(false);
      }
    };

    fetchContactContent();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center" role="alert">
        {error}
      </div>
    );
  }

  return <Contact content={contactContent} />;
}
